export default {
	attributes: {
		playButtonType: 'normal',
		previewBackgroundColor: '#000000',
		previewBackgroundMediaUrl: 'https://source.unsplash.com/800x500/?sea,coast,water',
		previewBackgroundCustomSizeUnit: '%',
		previewTabletBackgroundCustomSizeUnit: '%',
		previewMobileBackgroundCustomSizeUnit: '%',
		uniqueClass: 'ugb-ee3d6d0',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
}
